export default "__VITE_ASSET__D2rje1_O__"